import { render } from "./AllDistributorInvoicesView.vue?vue&type=template&id=d4f9c220"
import script from "./AllDistributorInvoicesView.vue?vue&type=script&lang=js"
export * from "./AllDistributorInvoicesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__